export const COMMON_API_ENDPOINTS = {
  // all api's

  DIVISION_HEAD: () => `/users/hr-info/division-head`,
  REVIEWER: () => `/employee/getReviewer
    `,
  REPORTING_MANAGER: () => `/users/hr-info/reporting-manager`,
  EMPLOYEES: () => `/employee/getActiveEmployees`,
  INACTIVE_EMPLOYEES: () => `/employee/getInactiveEmployees`,
  // Country
  STATE: ({ org }) => `/country/state?country=${org}`,

  PAYROLL_STATUS: ({ org }) => `employee/getRoleOfIntake?org=${org}`,

  ORGANIZATION: () => `/employee/getOrg`,
  ROLE_TYPE: ({ accessType }) => `/settings?referenceName=${accessType}`,

  // department, desigination, gender and band only
  COMMON_API: (referenceName) =>
    `/employee/getGender?referenceName=${referenceName}`,

  // Settings (Generic handler)
  SETTINGS: ({ name }) => `/settings?referenceName=${name}`,

  ALLEMPLOYEES: () => `employee/getEmpByStatus`,
  ALLORGEMPLOYEES: () => `/employee/getActiveEmp-parentOrg`,
};
